import { cable } from '@hotwired/turbo-rails'

// Every WebSocket holds a thread of the Apache in front of the cable server, and Turbo keeps the
// one a page opened for as long as the tab lives: a page without a stream closes it, and the next
// stream opens a new one.
document.addEventListener('turbo:load', async () => {
  const consumer = await cable.getConsumer()
  if (consumer.subscriptions.subscriptions.length === 0) consumer.disconnect()
})
